// extracted by mini-css-extract-plugin
export var lg = "_1r-4";
export var md = "_1r-3";
export var sm = "_1r-2";
export var xs = "_1r-1";
export var xxs = "_1r-0";